import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { PixelService } from '../../services/pixel.service';

@Component({
    selector: 'app-banner',
    templateUrl: './banner.component.html',
    styleUrl: './banner.component.scss',
    standalone: false
})
export class BannerComponent {
  lang: string = '';
  private readonly translate = inject(TranslateService);
  private readonly pixelService = inject(PixelService);

  constructor() {
    this.translate.onLangChange.pipe(takeUntilDestroyed()).subscribe((params: LangChangeEvent) => {
      this.lang = params.lang;
    });
  }

  trackDocumentClick(docName: string, url: string): void {
    this.pixelService.trackPageClick(url, docName);
  }
}
